import React, { Component } from 'react'
import { withMedia } from 'react-media-query-hoc'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import MenuIcon from '@mui/icons-material/Menu'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import _ from 'lodash'

import styles from './app.module.css'
import AppMenu from './AppMenu'
import UserMenu from './UserMenu'
import MenuAlertas from './alertas/MenuAlertas'
import MenuUnidades from './itens/unidades/MenuUnidades'
import MenuSelecaoSistemas from '@sesol-3/gerencial-lib/dist/components/dialogs/MenuSelecaoSistemas'
import {
  temUnidadesAtuaisSelecionadas,
  temVinculacaoHierarquica
} from '../controllers/unidadesController'
import {
  sistemas,
  visoesProcessos,
  visoesDocumentos,
  visoesComunicacoes,
  visoesProcessosAdm,
  visualizarUrlSistemaLinksPrincipais
} from '../controllers/itensController'
import { atualizarFiltros } from '../actions/filtrosActions'
import DialogMenusETCUUsuario from './itens/DialogMenusETCUUsuario'
import MenuGerirFiltrosObjetosUsuario from './MenuGerirFiltrosObjetosUsuario'

export class AppToolbar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menuUsuariosOpen: false
    }
    this.handleMenusUsuarioClose = this.handleMenusUsuarioClose.bind(this)
  }

  handleVisaoItemAtualSelectChange(visao, idSistema) {
    const {
      filtros: { responsabilidadeUnidade },
      unidadesUsuario: {
        unidadeVinculacaoHierarquica: { codigoUnidade }
      }
    } = this.props
    const urlParams = `?redirectTo=/visao/${visao}&codigoUnidadeAtual=${codigoUnidade}&responsabilidadeUnidade=${responsabilidadeUnidade}`
    const callback = (url) => window.open(`${url}${urlParams}`, '_blank')
    visualizarUrlSistemaLinksPrincipais(idSistema, callback)
  }

  handleMenusUsuarioClose() {
    this.setState({ menuUsuariosOpen: false })
  }

  handleMenusUsuarioOpen() {
    this.setState({ menuUsuariosOpen: true })
  }

  renderToobalTitle() {
    return (
      <img
        src='/images/logo-e-tcu-gerencial-cr.svg'
        alt='e-TCU_logomarca'
        id='button-main-home'
        className={classNames(styles.marcaSimboloItem, styles.logoETCUGerencial)}
        onClick={() => this.props.history.push('/')}
      />
    )
  }

  renderVisoesSelect(visoes, idSistema) {
    const visoesGreatherThanOne = _.size(_.entries(visoes).slice(1)) > 1
    const showSelect = visoesGreatherThanOne
    return showSelect ? (
      <Select
        sx={{ border: 'none', '& .MuiOutlinedInput-notchedOutline': { border: 'none' } }}
        className={styles.selectVisoes}
        value={`visao${_.capitalize(idSistema)}`}
        onChange={(event) => this.handleVisaoItemAtualSelectChange(event.target.value, idSistema)}>
        <MenuItem value={_.first(_.keys(visoes))}>{_.first(_.values(visoes))}</MenuItem>
        {_.map(_.entries(visoes).slice(1), ([key, label]) => (
          <MenuItem
            key={`visao-${idSistema}-${key}-button`}
            id={`visao-${idSistema}-${key}-button`}
            value={key}>
            {label}
          </MenuItem>
        ))}
      </Select>
    ) : (
      <Button
        color='primary'
        size='small'
        className={styles.selectVisoes}
        onClick={() => this.handleVisaoItemAtualSelectChange(_.last(_.keys(visoes)), idSistema)}>
        {_.first(_.values(visoes))}
      </Button>
    )
  }

  renderVisoesBar() {
    return (
      <React.Fragment>
        <Grid item>{this.renderVisoesSelect(visoesProcessos, sistemas.processos.id)}</Grid>
        <Grid item>{this.renderVisoesSelect(visoesProcessosAdm, sistemas.processosAdm.id)}</Grid>
        <Grid item>{this.renderVisoesSelect(visoesDocumentos, sistemas.documentos.id)}</Grid>
        <Grid item>{this.renderVisoesSelect(visoesComunicacoes, sistemas.comunicacoes.id)}</Grid>
      </React.Fragment>
    )
  }

  renderETCUSubMenu() {
    const {
      media,
      filtros: { unidadesAtuais },
      unidadesUsuario: { unidadeVinculacaoHierarquica }
    } = this.props
    return (
      !media.xs &&
      temUnidadesAtuaisSelecionadas(unidadesAtuais) && (
        <Box display='flex' alignItems='center'>
          <Box>
            <MenuGerirFiltrosObjetosUsuario />
          </Box>
          {this.renderVisoesBar()}
          {temVinculacaoHierarquica(unidadeVinculacaoHierarquica) && (
            <Box m={1}>
              <MenuAlertas />
            </Box>
          )}
          <Box>
            <MenuSelecaoSistemas />
          </Box>
        </Box>
      )
    )
  }

  renderToolbarContents() {
    const { media, authentication, userMenuAnchorEl, handleUserMenuOpen, handleUserMenuClose } =
      this.props
    return (
      authentication &&
      authentication.isUserAuthenticated && (
        <Box display='flex' alignItems='center' width={1}>
          <Box width={42}>
            <IconButton size='small' onClick={() => this.handleMenusUsuarioOpen()}>
              <MenuIcon style={{ color: '#757575' }} />
            </IconButton>
          </Box>
          <Box width={42} style={{ height: 42 }}>
            {this.renderToobalTitle()}
          </Box>
          <Box width={176}>
            <Box display='flex' alignItems='baseline' width={1} style={{ marginRight: 8 }}>
              <Box
                id={`menu-selecao-sistemas`}
                style={{ cursor: 'pointer' }}
                width={100}
                mx={1}
                onClick={(event) => this.setState({ anchorEl: event.currentTarget })}>
                <Typography
                  id='titulo-modulo'
                  variant='subtitle1'
                  color='textPrimary'
                  style={{ lineHeight: '1rem', fontWeight: 500 }}>
                  Minha Página
                </Typography>
                <Typography
                  id='subtitulo-etcu'
                  variant='body2'
                  color='textSecondary'
                  onClick={() => this.props.history.push('/')}>
                  e-TCU
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box data-tour='selecao-unidade-tecnica' style={{ height: 35 }}>
            <MenuUnidades hideMenuUnidades />
          </Box>
          <Box style={{ flexGrow: 1 }} display='flex' justifyContent='flex-end'>
            {this.renderETCUSubMenu()}
          </Box>
          {!media.xs && !media.sm ? (
            <Box>
              <UserMenu
                userMenuAnchorEl={userMenuAnchorEl}
                handleUserMenuOpen={handleUserMenuOpen}
                handleUserMenuClose={handleUserMenuClose}
              />
            </Box>
          ) : null}
        </Box>
      )
    )
  }

  render() {
    const {
      authentication,
      mainMenu: { mainMenuOpen },
      handleMainMenuClose
    } = this.props
    const { menuUsuariosOpen } = this.state
    return (
      <React.Fragment>
        <AppBar
          elevation={0}
          className={classNames(styles.appBar, {
            [styles.appBarShift]: mainMenuOpen,
            [styles.appBarShiftLeft]: mainMenuOpen
          })}>
          {(authentication && authentication.isUserAuthenticated && (
            <Toolbar>{this.renderToolbarContents()}</Toolbar>
          )) || <div />}
        </AppBar>
        <AppMenu handleMainMenuClose={handleMainMenuClose} />
        <DialogMenusETCUUsuario
          open={menuUsuariosOpen}
          handleMenusUsuarioClose={this.handleMenusUsuarioClose}
        />
      </React.Fragment>
    )
  }
}

const mediaQueryEnhanced = withMedia(AppToolbar)

const mapStateToProps = ({ authentication, mainMenu, filtros, unidadesUsuario, itens }) => ({
  authentication,
  mainMenu,
  filtros,
  unidadesUsuario,
  itens
})

const reduxEnhanced = connect(mapStateToProps, { atualizarFiltros })(mediaQueryEnhanced)

export default withRouter(reduxEnhanced)
